export default {
    getAdminPanelState(state) {
        return state.adminPanel;
    },
    getCompanyLicence(state) {
        return state.companyLicence;
    },
    getQueuedJobs(state) {
        return state.queued_jobs;
    },
}